import { render, staticRenderFns } from "./followup.vue?vue&type=template&id=84a15256&scoped=true&"
import script from "./followup.vue?vue&type=script&lang=js&"
export * from "./followup.vue?vue&type=script&lang=js&"
import style0 from "./followup.vue?vue&type=style&index=0&id=84a15256&scoped=true&lang=css&"
import style1 from "./followup.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a15256",
  null
  
)

export default component.exports